import { createApp } from 'vue';
import VueTippy from 'vue-tippy';
import App from './App.vue';
import store from './services/store';
import router from './router';
import http from './services/http';

const app = createApp(App);
app.use(router);
app.use(store);

app.config.productionTip = false;

app.use(VueTippy, {
  arrow: true,
  onShow: (options) => (!!options.props.content),
});

/* Expose webpack DefinePlugin variables injected during build. */
Object.assign(window.FINANCE, process.env);

http.initialize().then(() => {
  app.mount('#app');
});
